var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSSupplierTrusted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-trusted-supplier",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.797,13.568c0,-0.481 0.197,-0.943 0.54,-1.266l2.853,-2.694c0.066,-0.061 0.15,-0.091 0.222,-0.141c-0.406,-0.935 -1.281,-1.599 -2.349,-1.599l-2.531,-0c-1.399,-0 -2.532,1.135 -2.532,2.531l-0,3.798c-0,0.699 0.567,1.266 1.23,1.266l0.036,5.271c-0,0.699 0.567,1.266 1.266,1.266l2.531,-0c0.699,-0 1.266,-0.567 1.266,-1.266l0,-4.021l-1.992,-1.88c-0.377,-0.324 -0.54,-0.787 -0.54,-1.265Zm16.406,-7.011c1.259,-0 2.278,-1.019 2.278,-2.279c0,-1.259 -1.019,-2.278 -2.278,-2.278c-1.26,-0 -2.279,1.019 -2.279,2.278c0,1.26 1.018,2.279 2.279,2.279Zm-16.406,-0c1.26,-0 2.279,-1.019 2.279,-2.279c-0,-1.259 -1.018,-2.278 -2.279,-2.278c-1.26,-0 -2.278,1.019 -2.278,2.278c-0,1.26 1.019,2.279 2.278,2.279Zm14.37,6.663l-2.852,-2.69c-0.138,-0.131 -0.341,-0.166 -0.515,-0.091c-0.173,0.075 -0.288,0.245 -0.288,0.435l-0,1.424l-5.063,-0l-0,-1.424c-0,-0.19 -0.113,-0.361 -0.288,-0.436c-0.175,-0.074 -0.377,-0.074 -0.515,0.092l-2.852,2.69c-0.191,0.179 -0.191,0.511 -0,0.691l2.852,2.692c0.138,0.131 0.341,0.166 0.515,0.091c0.173,-0.072 0.288,-0.247 0.288,-0.436l-0,-1.428l5.063,-0l-0,1.429c-0,0.19 0.113,0.362 0.287,0.437c0.174,0.075 0.377,0.039 0.515,-0.091l2.853,-2.693c0.19,-0.178 0.19,-0.51 -0,-0.692Zm3.301,-5.352l-2.531,-0c-1.033,-0 -1.977,0.663 -2.349,1.598c0.073,0.051 0.157,0.081 0.222,0.142l2.853,2.693c0.342,0.321 0.54,0.784 0.54,1.267c-0,0.481 -0.197,0.942 -0.54,1.266l-1.992,1.879l-0,4.021c-0,0.699 0.567,1.266 1.266,1.266l2.531,-0c0.699,-0 1.266,-0.567 1.266,-1.266l0,-5.271c0.699,-0 1.266,-0.567 1.266,-1.266l-0,-3.798c-0,-1.396 -1.135,-2.531 -2.532,-2.531Z",
    style: {
      fill: "#01b800",
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-megaphone-light"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSSupplierTrusted);
export default __webpack_public_path__ + "static/media/iconS-supplier-trusted.3037025207260a21429f13d33912a950.svg";
export { ForwardRef as ReactComponent };